import { PubSub } from '@bark/bark-core';
import {_t, _l} from '@bark/bark-core';
import { parsePhoneNumber } from 'libphonenumber-js';

const formatPhoneNumber = function (phoneNumber) {
	let phoneNumberToDisplay = '',
		phoneNumberToDial = '#';
	if (phoneNumber && phoneNumber.length) {
		// attempt to parse and format the number
		try {
			const parsedNumber = parsePhoneNumber(
				phoneNumber,
				Bark.ENV.locale.toUpperCase(),
			);
			phoneNumberToDisplay = parsedNumber.formatNational();
			phoneNumberToDial = parsedNumber.getURI().replace('tel:', 'sms:');
		} catch (e) {
			window.bugsnagClient.notify(e);
		}
		// Fallback to provided number
		if (phoneNumberToDisplay === '') {
			phoneNumberToDisplay = phoneNumber;
			// remove any possible extension, or any non-numeric characters
			phoneNumberToDial =
				'tel:' +
				phoneNumberToDisplay
					.toLowerCase()
					.split('x')[0]
					.replace(/[^0-9+]/, '');
		}
	}
	return {
		dial: phoneNumberToDial,
		display: phoneNumberToDisplay,
	};
};

const SMSObject = function (data) {
	const { Bark } = window;

	let instanceVars = {
		data: {
			content: '',
		},
		editTimeout: null,
		maxCharacters: 800,
		whitelistTags: ['customer_name'],
		setContent: function (content) {
			content = this.checkTags(content);
			this.data.content = content;
		},
		charCount: function (content) {
			if (typeof content === 'undefined') {
				content = this.data.content;
			}
			let contentLength = content.length;
			let matches = content.match(new RegExp('{{[a-zA-Z_]+}}', 'gi'));
			let tagDiff = 0;
			if (matches) {
				matches.forEach((match) => {
					tagDiff = tagDiff + match.length;
				});
			}
			return contentLength - tagDiff;
		},
		charRemaining: function () {
			return this.maxCharacters - this.charCount();
		},
		checkTags: function (content) {
			if (typeof content === 'undefined') {
				content = this.data.content;
			}
			let newContent = content.replace(new RegExp('{+[^}]+}+', 'gi'), (tag) => {
				if (!tag.match(new RegExp('{{2}[^}]+}{2}'))) {
					return '';
				}
				let tagName = tag.replace('{{', '').replace('}}', '');
				if (!this.whitelistTags.includes(tagName)) {
					return '';
				}
				return tag;
			});
			return newContent;
		},
		modalContentUpdated: function () {
			let t = this;
			if (this.editTimeout) {
				clearTimeout(this.editTimeout);
			}
			this.editTimeout = setTimeout(function () {
				let content = $('#sms_content').val();
				t.setContent(content);
				if (t.data.content.length !== content) {
					$('#sms_content').val(t.data.content);
				}
				let count = t.charRemaining();
				let $el = $('.char-count-val');
				if (count < 0) {
					$el.parent().addClass('text-danger').removeClass('text-grey-400');
					$('.modal-submit').addClass('disabled');
				} else {
					$el.parent().removeClass('text-danger').addClass('text-grey-400');
					$('.modal-submit').removeClass('disabled');
				}
				$el.text(count);
			}, 100);
		},
		sendSMS: function (
			{ projectResponseId, templateId = null, message = null },
			onSuccess,
			onFailure,
		) {
			let t = this;
			let payload = {
				project_response_id: projectResponseId,
			};
			let event = 'sms.custom_sent';
			if (templateId) {
				payload.template_id = templateId;
				event = 'sms.template_sent';
			} else {
				payload.message = message;
			}
			Bark.api(
				'response/sms/',
				payload,
				() => {
					if (onSuccess()) {
						onSuccess();
					}
					this.fireEvent(event);
				},
				(error) => {
					let errorMessage = _t('seller_sms-template-manager:fail-to-send-error');
					if (
						error.responseJSON &&
						error.responseJSON.error &&
						error.responseJSON.error.errors
					) {
						if (error.responseJSON.error.errors.project_response_id) {
							errorMessage = error.responseJSON.error.errors.project_response_id[0];
						} else if (error.responseJSON.error.errors.message) {
							errorMessage = error.responseJSON.error.errors.message[0];
						}
					} else if (error.responseJSON && error.responseJSON.message) {
						let message = error.responseJSON.message;
						if (message === 'SMS Template not found') {
							errorMessage = message;
							Bark.SMSTemplates.refresh();
						}
					}
					onFailure(errorMessage);
				},
				'POST',
			);
		},
	};

	return Object.assign(this, PubSub, instanceVars);
};

let SMSCustom = function (data) {
	const { Handlebars, Bark } = window;
    const SMSTemplates = new SMSTemplatesManager()

	const createSMS = Handlebars.compile(
		document.getElementById('create-sms-modal').innerHTML,
		{ noEscape: true },
	);
	const templateQuestion = Handlebars.compile(
		document.getElementById('save-as-template-modal').innerHTML,
		{ noEscape: true },
	);

	const smsobj = SMSObject.call(this, data);
	const instanceVars = {
		data: {
			buyer: {
				name: '',
				phone: '',
				templateAsk: true,
			},
			content: '',
		},
		projectResponseId: null,
		set: function ({
			buyerName,
			buyerPhone,
			projectResponseId,
			content = '',
			templateAsk = true,
		}) {
			this.data.buyer = {
				name: buyerName,
				phone: buyerPhone,
				templateAsk: templateAsk,
			};
			if (this.data.buyer.templateAsk) {
				this.getTemplateAsk();
			}
			this.projectResponseId = projectResponseId ? projectResponseId : null;
			content = content.replace(new RegExp('{{customer_name}}', 'gi'), buyerName);
			this.setContent(content);
		},
		getTemplateAsk: function () {
			const preferenceName = 'seller.sms.template_ask';
			Bark.api(
				'ui-preferences/?names[]=' + preferenceName,
				{},
				(response) => {
					let { data } = response;
					this.data.buyer.templateAsk = data[preferenceName];
					this.fireEvent('update_template_ask', this.data.buyer.templateAsk);
				},
				(error) => {
					console.error(error);
				},
				'GET',
			);
		},
		setTemplateAsk: function (ask) {
			const preferenceName = 'seller.sms.template_ask';
			Bark.api(
				'ui-preferences/',
				{
					name: preferenceName,
					value: ask ? 1 : 0,
				},
				(response) => {
					let { data } = response;
					this.data.buyer.templateAsk = data[preferenceName];
					this.fireEvent('update_template_ask', this.data.buyer.templateAsk);
				},
				(error) => {
					console.error(error);
				},
				'PUT',
			);
		},
		getData: function () {
			let count = this.charRemaining();
			return {
				buyerName: this.data.buyer.name,
				buyerPhone: this.data.buyer.phone,
				content: this.data.content,
				charRemaining: count,
				charMax: this.maxCharacters,
				excess: count < 0 ? true : false,
			};
		},
		loadCustomSMSModal: function (onSubmit, onFailure) {
			let t = this;
			let smsFormHtml = createSMS(this.getData());
			modalManager.set(
				'',
				'',
				smsFormHtml,
				[
					`<button class="btn btn-primary large-btn submit modal-submit d-flex justify-content-center align-items-center px-5" type="button"><span class="submit-spinner spinner-border spinner-border-md my-n1 mx-4" role="status" aria-hidden="true"></span><span class="submit-text">${_t('seller_sms-template-manager:send-sms-button')}</span></button>`,
				],
				['footer-justify-center', 'no-modal-header', 'alt-modal-alerts'],
			);
			setTimeout(function () {
				$('#sms_content').focus();
				t.modalContentUpdated();
			}, 0);
			modalManager.setEvent('input change keyup', '#sms_content', {}, function (e) {
				t.modalContentUpdated();
			});
			modalManager.setEvent(
				'click touchstart',
				'.modal-submit:not(.disabled)',
				{},
				function (e) {
					let $el = $(e.currentTarget);
					if (!$el.hasClass('submit-waiting')) {
						$el.addClass('submit-waiting disabled');
						t.send(onSubmit, function () {
							$el.removeClass('submit-waiting disabled');
							if (onFailure) {
								onFailure();
							}
						});
					}
				},
			);
		},
		loadTemplateQuestionModal: function () {
			let t = this;
			let smsFormHtml = templateQuestion();
			modalManager.set('', '', smsFormHtml, [], ['no-modal-header']);
			modalManager.setEvent('change', '#dont_ask_template_question', {}, function (e) {
				t.setTemplateAsk(!$('#dont_ask_template_question').prop('checked'));
			});
			modalManager.setEvent('click touchstart', '.modal-submit', {}, function (e) {
				let content = t.data.content;
				content = content.replace(
					new RegExp('\\b' + t.data.buyer.name + '\\b', 'gi'),
					'{{customer_name}}',
				);
				let template = SMSTemplates.newTemplate({ content: content });
				template.loadEditModal();
			});
		},
		send: function (onSubmit, onFailure) {
			let t = this;
			let handleSuccess = function () {
				if (onSubmit) {
					onSubmit();
				}
				modalManager.showSuccessModal(_t('seller_sms-template-manager:send-success-msg'), '', 2);
				if (t.data.buyer.templateAsk) {
					setTimeout(function () {
						t.loadTemplateQuestionModal();
					}, 2000);
				}
			};
			let handleFailure = function (errorMessage) {
				if (onFailure) {
					onFailure();
				}
				modalManager.showError(errorMessage);
			};
			this.sendSMS(
				{
					projectResponseId: this.projectResponseId,
					message: this.data.content,
				},
				handleSuccess,
				handleFailure,
			);
		},
	};

	const _this = Object.assign(this, smsobj, instanceVars);

	_this.set(data);

	return _this;
};

const SMSTemplate = function (data) {
	const smsobj = SMSObject.call(this, data);
	const { Handlebars } = window;
	const editTemplate = Handlebars.compile(
		document.getElementById('edit-sms-template-modal').innerHTML
	);

	const instanceVars = {
		id: null,
		original: {
			title: '',
			content: '',
		},
		data: {
			title: '',
			content: '',
		},
		set: function (data) {
			if (typeof data !== 'undefined') {
				let { id = null, title = '', content = '' } = data;
				this.id = id;
				this.setTitle(title);
				this.setContent(content);
			}
			this.syncData();
		},
		setTitle: function (title) {
			this.data.title = title;
		},
		getData: function () {
			let count = this.charRemaining();
			return {
				id: this.id,
				title: this.data.title,
				content: this.data.content,
				charRemaining: count,
				charMax: this.maxCharacters,
				excess: count < 0 ? true : false,
			};
		},
		getContent: function () {
			return this.data.content;
		},
		isNew: function () {
			return this.id === null;
		},
		resetData: function () {
			this.data = JSON.parse(JSON.stringify(this.original));
		},
		syncData: function () {
			this.original = JSON.parse(JSON.stringify(this.data));
		},
		loadEditModal: function () {
			let t = this;
			this.resetData();
			let smsFormHtml = editTemplate(this.getData());
			modalManager.set(
				this.isNew() ? _t('seller_sms-template-manager:create-label') : _t('seller_sms-template-manager:edit-label'),
				'',
				smsFormHtml,
				[
					`<button class="btn btn-primary px-5 py-3 text-xs-14 modal-submit" type="button"><span class="submit-spinner spinner-border spinner-border-sm" role="status" aria-hidden="true"></span><span class="submit-text">${_t('seller_sms-template-manager:save-button')}</span></button>`,
				],
				['footer-justify-end'],
			);
			setTimeout(function () {
				t.modalContentUpdated();
			}, 0);
			modalManager.setEvent('click touchstart', '.insert-tag', {}, function (e) {
				e.preventDefault();
				let tag = '{{' + $(e.target).data('tag') + '}}';
				let $textarea = $('#sms_content');
				let pos = $textarea[0].selectionStart;
				let currentContent = $textarea.val();
				$textarea.val(
					currentContent.substring(0, pos) + tag + currentContent.substring(pos),
				);
				$textarea.focus();
				$textarea.prop('selectionEnd', pos + tag.length);
				t.modalContentUpdated();
			});
			modalManager.setEvent('input change keyup', '#sms_content', {}, function (e) {
				t.modalContentUpdated();
			});
			modalManager.setEvent('input change keyup', '#sms_title', {}, function (e) {
				t.setTitle($('#sms_title').val());
			});
			modalManager.setEvent(
				'click touchstart',
				'.modal-submit:not(.disabled)',
				{},
				function (e) {
					let $el = $(e.currentTarget);
					if (!$el.hasClass('submit-waiting')) {
						$el.addClass('submit-waiting disabled');
						t.on('failed_save', function () {
							$el.removeClass('submit-waiting disabled');
						});
						t.save();
					}
				},
			);
		},
		loadDeleteModal: function (callback) {
			let t = this;
			modalManager.set(
				'',
				'',
				`<h4 class="text-center mb-0">${_t('seller_sms-template-manager:confirm-remove')}</h4>`,
				[
					modalManager.cancelLinkHTML(),
					`<button class="btn btn-danger submit modal-submit confirm-delete-template" type="button"><span class="submit-spinner spinner-border spinner-border-sm" role="status" aria-hidden="true"></span><span class="submit-text">${_t('seller_sms-template-manager:remove-button')}</span></button>`,
				],
				['modal-sm'],
			);
			modalManager.setEvent(
				'click touchstart',
				'.confirm-delete-template',
				{},
				function (e) {
					Bark.emailService(
						'user/sms/' + t.id,
						{},
						function (data) {
							callback();
						},
						function (error) {
							window.bugsnagClient.notify(
								new Error('Seller delete sms template failed'),
								{ metaData: error },
							);
							callback();
						},
						'DELETE',
					);
					modalManager.destroy();
				},
			);
		},
		save: function () {
			let t = this;
			let payload = {
				title: this.data.title,
				content: this.data.content,
			};
			let errorMsg = null;
			if (errorMsg) {
				modalManager.showError(errorMsg);
				this.fireEvent('failed_save');
				return;
			}
			let method = 'PUT';
			let route = 'user/sms/';
			if (!this.isNew()) {
				method = 'PATCH';
				route = 'user/sms/' + this.id + '/';
			}
			Bark.emailService(
				route,
				payload,
				(data) => {
					this.id = data.data.id;
					this.data.title = data.data.title;
					this.data.content = data.data.content;
					this.syncData();
					this.fireEvent('updated', this);
					modalManager.showSuccessModal(_t('seller_sms-template-manager:save-success-msg'), '', 2);
				},
				function (error) {
					let errorMsg =
						_t('seller_sms-template-manager:save-error-msg');
					try {
						let {
							responseJSON: { error: errorStatus, errors },
						} = error;
						if (
							typeof errorStatus !== 'undefined' &&
							errorStatus === 'Validation error'
						) {
							let errorMsgs = [];
							Object.values(errors).forEach((msgs) => {
								msgs.forEach((msg) => {
									errorMsgs.push(msg);
								});
							});
							errorMsg = errorMsgs.join('<br>');
						}
						t.fireEvent('failed_save');
					} catch (e) {
						window.bugsnagClient.notify(new Error('Seller save sms template failed'), {
							metaData: error,
						});
					}
					modalManager.showError(errorMsg);
				},
				method,
			);
		},
		delete: function (callback) {
			this.loadDeleteModal(callback);
		},
	};

	const _this = Object.assign(this, smsobj, instanceVars);

	_this.set(data);

	return _this;
};

export const SMSTemplatesManager = () => {
	const { Handlebars, Bark } = window;
	const templatePicker = Handlebars.compile(
		document.getElementById('template-picker-modal').innerHTML,
		{ noEscape: true },
	);
	const manualSMS = Handlebars.compile(
		document.getElementById('manual-sms-modal').innerHTML,
		{ noEscape: true },
	);

	let instanceVars = {
		templates: [],
		templateAsk: true,
		getTemplates: function () {
			let t = this;
			Bark.emailService(
				'user/sms/',
				{},
				function (data) {
					let { data: templates } = data;
					t.templates = templates;
					t.fireEvent('got_templates', templates);
				},
				function (error) {
					t.fireEvent('failed_got_templates', error);
				},
				'GET',
			);
		},
		hasTemplates: function () {
			return this.templates.length > 0;
		},
		findTemplate: function (id) {
			let templateData = {};
			this.templates.forEach((template) => {
				if (template.id === parseInt(id)) {
					templateData = template;
				}
			});
			return this.newTemplate(templateData);
		},
		refresh: function () {
			this.getTemplates();
		},
		newTemplate: function (data) {
			let t = this;
			let template = new SMSTemplate(data);

			this.propogateEvents(template, ['sms.template_sent', 'sms.custom_sent']);
			template.on('updated', function () {
				t.refresh();
			});
			return template;
		},
		newCustom: function (data) {
			if (this.hasTemplates() || !this.templateAsk) {
				data.templateAsk = false;
			}
			let custom = new SMSCustom(data);
			custom.on('update_template_ask', function (value) {
				this.templateAsk = value;
			});
			this.propogateEvents(custom, ['sms.template_sent', 'sms.custom_sent']);
			return custom;
		},
		propogateEvents: function (object, events) {
			events.forEach((event) => {
				object.on(event, (data) => {
					this.fireEvent(event, data);
				});
			});
		},
		loadManualSMSModal: function ({ buyerName, buyerPhone }, onSubmit, onCancel) {
			let t = this;
			let sent = false;
			let { dial, display } = formatPhoneNumber(buyerPhone);
			let smsFormHtml = manualSMS({
				buyer_phone_dial: dial,
				buyer_phone_display: display,
				buyerName: buyerName,
			});
			modalManager.set(
				'',
				'',
				smsFormHtml,
				[
					`<button type="button" class="btn btn-outline-primary flex-grow-1 flex-sm-grow-0 px-sm-5 py-3 text-xs-14 mr-4" data-dismiss="modal">${_t('seller_sms-template-manager:cancel-button')}</button>`,
					`<button class="btn btn-primary flex-grow-1 flex-sm-grow-0 px-sm-5 py-3 text-xs-14 modal-submit" type="button"><span class="submit-spinner spinner-border spinner-border-sm" role="status" aria-hidden="true"></span><span class="submit-text"><span class="submit-text">${_t('seller_sms-template-manager:sent-sms-button')}</span></button>`,
				],
				['footer-justify-center', 'no-modal-header'],
			);
			modalManager.setEvent('click touchstart', '.modal-submit', {}, function (e) {
				sent = true;
				onSubmit();
				modalManager.destroy();
			});
			modalManager.setEvent('hide.bs.modal', null, {}, function (e) {
				if (!sent) {
					onCancel();
				}
			});
		},
		loadTemplatePickerModal: function (
			{ buyerName, buyerPhone, projectResponseId },
			onSubmit,
			onFailure,
		) {
			let t = this;
			let selected = true;
			let templateChoices = this.templates.map((template) => {
				if (selected) {
					template.selected = selected;
					selected = false;
				} else {
					template.selected = selected;
				}
				return template;
			});
			let smsFormHtml = templatePicker({ templates: templateChoices });
			modalManager.set(
				_t('seller_sms-template-manager:use-label'),
				_t('seller_sms-template-manager:select-label',{'buyer_public_name': buyerName}),
				smsFormHtml,
				[
					`<a href="#" class="prevew-and-edit mr-3">${_t('seller_sms-template-manager:preview-edit-button')}</a>`,
					`<button class="btn btn-primary large-btn submit modal-submit d-flex justify-content-center align-items-center" type="button"><span class="submit-spinner spinner-border spinner-border-md my-n1" role="status" aria-hidden="true"></span><span class="submit-text">${_t('seller_sms-template-manager:send-button')}</span></button>`,
				],
				['footer-justify-end'],
			);
			modalManager.setEvent(
				'click touchstart',
				'.sms-template-row:not(.selected)',
				{},
				function (e) {
					e.preventDefault();
					let $el = $(e.currentTarget);
					$('.sms-template-row').removeClass('selected').removeClass('border-primary');
					$el.addClass('selected').addClass('border-primary');
				},
			);
			modalManager.setEvent('click touchstart', '.prevew-and-edit', {}, function (e) {
				e.preventDefault();
				let template = t.findTemplate($('.sms-template-row.selected').data('id'));
				let customSMS = t.newCustom({
					content: template.getContent(),
					buyerName: buyerName,
					buyerPhone: buyerPhone,
					templateAsk: false,
					projectResponseId,
				});
				let handleSuccess = function () {
					if (onSubmit) {
						onSubmit();
					}
					modalManager.showSuccessModal(_t('seller_sms-template-manager:send-success-msg'), '', 2);
				};
				let handleFailure = function (errorMessage) {
					if (onFailure) {
						onFailure();
					}
					modalManager.showError(errorMessage);
				};
				customSMS.loadCustomSMSModal(handleSuccess, handleFailure);
			});
			modalManager.setEvent('click touchstart', '.modal-submit', {}, function (e) {
				let sms = new SMSObject();
				let $el = $(e.currentTarget);
				if (!$el.hasClass('submit-waiting')) {
					$el.addClass('submit-waiting disabled');
					t.propogateEvents(sms, ['sms.template_sent', 'sms.custom_sent']);
					let templateId = $('.sms-template-row.selected').data('id');
					let handleSuccess = function () {
						if (onSubmit) {
							onSubmit();
						}
						modalManager.showSuccessModal(_t('seller_sms-template-manager:send-success-msg'), '', 2);
					};
					let handleFailure = function (errorMessage) {
						if (onFailure) {
							onFailure();
						}
						$el.removeClass('submit-waiting disabled');
						modalManager.showError(errorMessage);
					};
					sms.sendSMS(
						{
							projectResponseId: projectResponseId,
							templateId: templateId,
						},
						handleSuccess,
						handleFailure,
					);
				}
			});
		},
	};

	return Object.assign(instanceVars, PubSub);
};
